import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { useHostAppProxy, ProxyEventTypes } from '../../../contexts/HostAppProxyContext';

interface SocialProfileLinksProps {
  socialProfiles?: {
    goodreads?: string;
    tome?: string;
    instagram?: string;
    tiktok?: string;
  };
  style?: React.CSSProperties;
}

const SocialProfileLinks: React.FC<SocialProfileLinksProps> = ({
  socialProfiles,
  style,
}) => {
  const { settings, sendMessageToHost } = useHostAppProxy();
  if (!socialProfiles || Object.values(socialProfiles).every(url => !url)) {
    return null;
  }

  const profileConfig = [
    {
      platform: 'goodreads',
      icon: 'book',
      color: 'brown' as const,
      label: 'Goodreads Profile',
    },
    {
      platform: 'tome',
      icon: 'book',
      color: 'blue' as const,
      label: 'Tome Profile',
    },
    {
      platform: 'instagram',
      icon: 'instagram',
      color: 'pink' as const,
      label: 'Instagram Profile',
    },
    {
      platform: 'tiktok',
      icon: 'video',
      color: 'black' as const,
      label: 'TikTok Profile',
    },
  ];

  return (
    <div style={{ marginTop: '4px', ...style }}>
      {profileConfig.map(({ platform, icon, color, label }) => {
        const url = socialProfiles[platform as keyof typeof socialProfiles];
        if (!url) return null;

        return (
          <Popup
            key={platform}
            content={`Visit ${label}`}
            trigger={
              <Icon
                name={icon as any}
                color={color}
                size="small"
                style={{
                  cursor: 'pointer',
                  marginRight: '4px',
                }}
                onClick={(e: any) => {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  // Open in native browser when running in mobile app
                  if (window.ReactNativeWebView || settings.isWrapped) {
                    sendMessageToHost({
                      type: ProxyEventTypes.OPEN_EXTERNAL_URL,
                      data: { url }
                    });
                  } else {
                    window.open(url, '_blank', 'noopener,noreferrer');
                  }
                }}
              />
            }
          />
        );
      })}
    </div>
  );
};

export default SocialProfileLinks;
